import React, { Component } from 'react'
import { JIAMENG_CUSTOMER_PATH } from '@constant'
import mainStore from '@components/Main/store'
import { observer } from 'mobx-react'
import Numbers from '../Numbers'
import style from './style.module.less'
import { hashHistory } from 'react-router'

@observer
export default class extends Component {
  render() {
    const { shopInfo } = mainStore
    const { new_feed_count, customer_stage } = shopInfo

    return (
      <Numbers
        title={
          <div className={style.title}>
            <span>客户</span>

            {new_feed_count > 0 && (
              <span
                className={style.notice}
                onClick={() => hashHistory.push(`${JIAMENG_CUSTOMER_PATH}`)}
              >
                <span style={{ marginRight: 6 }}>
                  {new_feed_count}个客户有新动态
                </span>
                <span>></span>
              </span>
            )}
          </div>
        }
        data={customer_stage || []}
        style={{ marginBottom: 20 }}
      />
    )
  }
}
